import { all } from "redux-saga/effects"
import AuthSaga from "./AuthSaga"
import ProductSaga from "./ProductSaga"
import userSaga from "./UserSaga"
import categorySaga from "./CategorySaga"
import FiltergetSaga from "./FiltergetSaga"
import WishListSaga from "./WishListSaga"
import AddCartSaga from "./AddCartSaga"
import DeliveryAddressSaga from "./DeliveryAddressSaga"
import CountrySaga from "./CountrySaga"


export default function* rootSaga() {
    yield all([
        AuthSaga(),
        ProductSaga(),
        userSaga(),
        categorySaga(),
        FiltergetSaga(),
        WishListSaga(),
        AddCartSaga(),
        DeliveryAddressSaga(),
        CountrySaga()
    ])
    // code after all-effect
  }